import Vue from "vue"
import VueI18n from "vue-i18n"

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context("@/translations", true, /\.json$/)
  const messages = {}

  locales.keys().forEach((key) => {
    const matched = key.match(/\/([a-zA-Z-]+)\/(.+)\.json$/)
    if (matched) {
      const locale = matched[1]; // de, en, etc.
      const namespace = matched[2].replace(/\//g, ".");

      if (!messages[locale]) messages[locale] = {}
      const fileContent = locales(key)

      Object.keys(fileContent).forEach((innerKey) => {
        messages[locale][`${namespace}.${innerKey}`] = fileContent[innerKey]
      })
    }
  })
  return messages
}

const defaultLang = localStorage.getItem("lang") || "de"

const i18n = new VueI18n({
  locale: defaultLang,
  fallbackLocale: "en",
  messages: loadLocaleMessages(),
})

export default i18n